import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import { jqTextCopy } from 'javascripts/general_scripts'
import { initLinkedinVerify } from 'javascripts/linkedin_verify'

jqTextCopy();
initLinkedinVerify({ feature: 'user' });

jQuery(() => {
  if (!HAS_OMNI) {
    import('javascripts/modal_verify');
  }
  $("#small_list").one('mouseover', function() { $.get($(this).data('hoverUrl')) });
});

document.addEventListener('turbo:before-stream-render', (event) => {
  const originalRender = event.detail.render;
  event.detail.render = function (streamElement) {
    originalRender(streamElement);
    if (streamElement.target === 'li_verify') {
      initLinkedinVerify({ feature: 'user' });
    }
  };
});
